import React, { Component } from "react";

import Sidebar from "./Sidebar";

import Navigation from "./Navigation";

import Home from "./Home";

import About from "./About";

import Resume from "./Resume";

import Portfolio from "./Portfolio";

import Contact from "./Contact";

import TypedText from "./TypedText";

class Main extends Component {

  state = {

    page: "home",

    language: "en",

  };

  // برای دسترسی به ریشه اصلی پروژه

  shellRef = React.createRef();

  // تغییر صفحه

  change = (p) => {

    this.setState({

      page: p,

    });

  };

  // تغییر زبان

  changeLanguage = () => {

    this.setState((prevState) => ({

      language: prevState.language === "en" ? "fa" : "en",

    }));

  };

  // اعمال زبان روی متن‌های دارای data-en و data-fa

  applyLanguage = () => {

    const root = this.shellRef.current;

    if (!root) return;

    const isFa = this.state.language === "fa";

    // تغییر زبان و جهت کل صفحه

    document.documentElement.lang = isFa ? "fa" : "en";

    document.documentElement.dir = isFa ? "rtl" : "ltr";

    // تغییر متن‌ها

    root.querySelectorAll("[data-en]").forEach((el) => {

      const value = el.getAttribute(

        isFa ? "data-fa" : "data-en"

      );

      if (value !== null) {

        el.textContent = value;

      }

    });

    // تغییر placeholder ها

    root.querySelectorAll("[data-ph-en]").forEach((el) => {

      const value = el.getAttribute(

        isFa ? "data-ph-fa" : "data-ph-en"

      );

      if (value !== null) {

        el.setAttribute("placeholder", value);

      }

    });

  };

  // اولین بار که کامپوننت ساخته شد

  componentDidMount() {

    this.applyLanguage();

  }

  // هر بار که state تغییر کرد

  componentDidUpdate() {

    this.applyLanguage();

  }

  render() {

    let content;

    if (this.state.page === "home") {

      content = (

        <Home

          onChangePanel={this.change}

          language={this.state.language}

        />

      );

    }

    if (this.state.page === "about") {

      content = (

        <About

          onChangePanel={this.change}

          language={this.state.language}

        />

      );

    }

    if (this.state.page === "resume") {

      content = (

        <Resume

          onChangePanel={this.change}

          language={this.state.language}

        />

      );

    }

    if (this.state.page === "portfolio") {

      content = (

        <Portfolio

          onChangePanel={this.change}

          language={this.state.language}

        />

      );

    }

    if (this.state.page === "contact") {

      content = (

        <Contact

          onChangePanel={this.change}

          language={this.state.language}

        />

      );

    }

    return (

      <div

        ref={this.shellRef}

        className={`resume-shell ${

          this.state.language === "fa" ? "rtl" : "ltr"

        }`}

        dir={this.state.language === "fa" ? "rtl" : "ltr"}

      >

        {/* فقط بک‌گراند تزئینی */}

        <div className="bg-decor" aria-hidden="true">

          <span className="blob blob-1"></span>

          <span className="blob blob-2"></span>

          <span className="dots dots-tl"></span>

        </div>


        <Sidebar

          onChangeLanguage={this.changeLanguage}

          language={this.state.language}

        />

        <main className="card-main">

          <div className="panel-viewport">

            {content}

          </div>

        </main>

        <Navigation

          onChangePanel={this.change}

          language={this.state.language}

        />

      </div>

    );

  }

}

export default Main;